// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"673":"dd970950","767":"da235fe6"}[chunkId] + ".chunk.js";
};